import { createI18n } from 'vue-i18n'
import zhCN from '@/locales/zh-CN'
import enUS from '@/locales/en-US'

// 获取系统语言
function getSystemLanguage() {
  const lang = navigator.language || navigator.userLanguage
  // 支持的语言映射
  const supportLanguages = ['zh-CN', 'en-US']
  
  if (supportLanguages.includes(lang)) {
    return lang
  }
  
  // 如果是zh开头的其他语言（如zh-TW），默认返回zh-CN
  if (lang.startsWith('zh')) {
    return 'zh-CN'
  }
  
  // 默认返回英文
  return 'en-US'
}

// 获取语言设置
function getLocale() {
  // 优先从localStorage获取
  const savedLocale = localStorage.getItem('locale')
  if (savedLocale && ['zh-CN', 'en-US'].includes(savedLocale)) {
    return savedLocale
  }
  
  // 没有则根据系统语言
  return getSystemLanguage()
}

const messages = {
  'zh-CN': zhCN,
  'en-US': enUS
}

const i18n = createI18n({
  legacy: false, // 使用Composition API
  locale: getLocale(),
  fallbackLocale: 'en-US', // 降级语言
  messages,
  globalInjection: true // 全局注入
})

export default i18n